import yaml from 'js-yaml';
import { rdwEndpointUrl } from "constants";
// fetch yml files
export const fetchReportFile = (fileLocation) => {
  let fileContents;
  if (fileContents = fetchYaml(fileLocation)) {
    return fileContents;
  } else {
    throw new Error("error fetching file", err);
  }
};

async function fetchYaml(path){
  let response = await self.fetch(path);
  let responseText = await response.text();
  if (response.ok) {
    return parseFile(responseText);
  } else {
    throw new Error(users);
  }
};

function parseFile(fileContents) {
  let doc = yaml.load(fileContents, 'utf8');
  return doc;
};

// fetching licenseplate results
export const fetchVehicles = (filter, query) => {
  // check correct fields in query (kenteken and type)
  let new_query = { kenteken: query.kenteken.toUpperCase(), type: query.type };
  // perform request
  let urlToFetch = buildQuery(filter, new_query);
  // console.log("url to fetch", urlToFetch);
  let results;
  if (results = fetchVehiclesFromRdw(urlToFetch)) {
    return results;
  } else {
    throw new Error("Error fetching RDW data",  err);
  };
  return urlToFetch;
  // format:
  // [
  //   {
  //     kenteken: "",
  //     merk: "",
  //     voertuigsoort: "Personenauto",
  //     handelsbenaming: "",
  //     inrichting: "Sedan",
  //     eerste_kleur: "Zwart",
  //     aantal_deuren: 4,
  //     aantal_wielen: 4,
  //     wam_verzekerd: "Ja",
  //     export_indicator: "Nee",
  //     taxi_indicator: "Nee",
  //   }
  // ]
};

function buildQuery(filter, query) {
  // fields to return (extend later on)
  let selectFields = "$SELECT=kenteken,merk,handelsbenaming,inrichting,voertuigsoort,eerste_kleur&";
  let url = rdwEndpointUrl + "?";

  if (Object.keys(filter).includes("merk")) {
    url = url + "merk=" + filter.merk + "&";
  };
  if (Object.keys(filter).includes("eerste_kleur")) {
    url = url + "eerste_kleur=" + filter.eerste_kleur + "&";
  };
  if (Object.keys(filter).includes("voertuigsoort")) {
    url = url + "voertuigsoort=" + filter.voertuigsoort + "&";
  };
  if (Object.keys(filter).includes("inrichting")) {
    url = url + "inrichting=" + filter.inrichting + "&";
  };
  url = url + selectFields;
  if (query.type === "startmet") {
    // kenteken start met
    let tempKenteken = query.kenteken.replaceAll("%", "%25");
    url = url + "$WHERE=starts_with(kenteken,%27"+ tempKenteken +"%27)";
  } else {
    // kenteken bevat
    if (query.kenteken.includes("%")) {
      // als % (%25) toegevoegd in query.kenteken, niet toevoegen, replacen met %25
      let tempKenteken = query.kenteken.replaceAll("%", "%25");
      url = url + "$WHERE=kenteken%20like%20%27"+ tempKenteken +"%27";
    } else {
      // als niet toegevoegd is, toevoegen (voor en achter)
      url = url + "$WHERE=kenteken%20like%20%27%25"+ query.kenteken +"%25%27";
    };
  }
  return url;
};

async function fetchVehiclesFromRdw(url) {
  let response = await self.fetch(url)
  if (response.ok) {
    return await response.json();
  } else {
    throw new Error("HTTP error, could not fetch from RDW: " + response.status);
  }
};

function compareLicensePlates(a,b) {
  if (a.kenteken < b.kenteken) {
    return -1;
  }
  if (a.kenteken > b.kenteken) {
    return 1;
  }
  return 0;
};

// sort by licenseplate
export const sortRdwResults = (results) => {
  let new_results = results.sort(compareLicensePlates);
  return new_results;
};
